import { Edit, SimpleForm, useRecordContext, SelectInput, TextInput, ArrayField, SingleFieldList, Toolbar, SaveButton } from 'react-admin';
import { Box, Typography, Paper, Grid, DateField, Divider } from '@mui/material';
import { AttributeItem } from './AttributeItem';
import { OrderItemsList } from './OrderItemsList';
import { OrderCustomerDetails } from './OrderCustomerDetails';

const OrderTitle = () => {
  return <span>{'訂單'}</span>
}

const statusMaps = {
  pending_payment: "待付款",
  pending_approval: "處理中",
  pending_receipt: "已出貨",
  completed: "已完成",
  canceled: "已取消",
}

const OrderStatusPanel = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
      <Paper sx={{ p: 3, width: 1200 }} elevation={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" fontWeight="bold">
                  訂單編號 {record.orderNo}
              </Typography>
              <Box sx={{ minWidth: 200 }}>
                  <SelectInput
                      source="status"
                      label="訂單狀態"
                      helperText={false}
                      choices={[
                          { id: 'pending_payment', name: '待付款' },
                          { id: 'pending_approval', name: '處理中' },
                          { id: 'pending_receipt', name: '已出貨' },
                          { id: 'completed', name: '已完成' },
                          { id: 'canceled', name: '已取消' },
                      ]}
                      isRequired
                  />
              </Box>
          </Box>
      </Paper>
    );
};

// 單筆歷史紀錄的顯示元件
const HistoryItem = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <Box sx={{ py: 2 }}>
          <Grid container spacing={2} rowSpacing={1}>
              <Grid item xs={12} md={6}>
                  <AttributeItem label="建立時間" value={record.createdAt} />
              </Grid>
              <Grid item xs={12} md={6}>
                  <AttributeItem label="訂單狀態" value={statusMaps[record.status]} />
              </Grid>
              <Grid item xs={12} md={6}>
                  <AttributeItem label="備註者" value={record.createdBy} />
              </Grid>
              <Grid item xs={12} md={6}>
                  <AttributeItem label="內容" value={record.note} />
              </Grid>
          </Grid>
          <Divider sx={{ mt: 2, borderStyle: 'dotted' }} />
        </Box>
    );
};

const BackendNotePanel = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
      <Paper sx={{ p: 3, width: 1200, mt: 3 }} elevation={2}>
        <Box sx={{ my: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
              後台備註
          </Typography>
          <TextInput
            source="backendNote"
            label={false}
            multiline
            rows={4}
            fullWidth
          />
        </Box>
        <Divider />
        <Box sx={{ mt: 3 }}>
            <ArrayField source="statusLogs">
                <SingleFieldList linkType={false}>
                  <HistoryItem />
                </SingleFieldList>
            </ArrayField>
        </Box>
      </Paper>
    );
};

export const OrderEdit = () => (
    <Edit 
      title={<OrderTitle/>} 
      redirect={false}
      mutationMode="optimistic"
    >
      <SimpleForm
        toolbar={
          <Toolbar>
            <SaveButton/>
          </Toolbar>
        }
      >
        <OrderStatusPanel />
        <BackendNotePanel />
        <OrderItemsList />
        <OrderCustomerDetails />
      </SimpleForm>
    </Edit>
);

export default OrderEdit